<template>
  <main>
    <h2 class="main-title">{{ $t("title") }}</h2>

    <div class="resume">
      <map-view
        :incidentsList="savedIncidentsList"
        :workplannedList="savedWorkplannedList"
        v-on:selected-department="onSelectedDepartment"
        :isListFiltered="isListFiltered"
      ></map-view>

      <div class="resume-detail">
        <status-view
          :nbCurrentIncidents="savedNbCurrentIncidents"
          :nbCurrentWorkplanned="savedNbCurrentWorkplanned"
          :isNationalIncident="isNationalIncident"
        ></status-view>
        <access-view></access-view>

        <button
          @click="refreshData"
          class="btn reload-button btn-outline-primary btn-sm"
          type="button"
        >
          <font-awesome-icon icon="sync-alt" />
          {{ $t("reload-data") }}
        </button>
      </div>
    </div>

    <tabs-view
      :nbIncidents="nbCurrentIncidents"
      :nbWorkplanned="nbCurrentWorkplanned"
      :incidentsList="incidentsList"
      :workplannedList="workplannedList"
    ></tabs-view>
  </main>
</template>

<script>
import AccessView from "./AccessView.vue";
import MapView from "./MapView.vue";
import StatusView from "./StatusView.vue";
import TabsView from "./TabsView.vue";

export default {
  name: "MainView",
  metaInfo() {
    return {
      title: this.$t("title-tab"),
    };
  },
  components: {
    AccessView,
    MapView,
    StatusView,
    TabsView,
  },
  data() {
    return {
      nbCurrentIncidents: 0,
      nbCurrentWorkplanned: 0,
      savedNbCurrentIncidents: 0,
      savedNbCurrentWorkplanned: 0,
      incidentsList: [],
      workplannedList: [],
      savedIncidentsList: [],
      savedWorkplannedList: [],
      hasLoadedIncidentsList: false,
      hasLoadedWorkplannedList: false,
      isListFiltered: false,
      isNationalIncident: false,
    };
  },
  created() {
    this.loadIncidentList();
    this.loadWorkplannedList();
  },
  methods: {
    loadIncidentList() {
      const url = `${this.$baseUrl}connectivity/monitoring/genericIncident/public`;

      this.incidentsList = [];
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          if (!data.message) {
            this.incidentsList = data;
            this.savedIncidentsList = data;
            this.hasLoadedIncidentsList = true;
            this.countNbIncidents();
            this.countNbIncidents(true);
          }
        });
    },
    loadWorkplannedList() {
      const url = `${this.$baseUrl}connectivity/maintenance/workPlanned/public`;

      this.workplannedList = [];
      fetch(url)
        .then((response) => response.json())
        .then((data) => {
          if (!data.message) {
            this.workplannedList = data;
            this.savedWorkplannedList = data;
            this.hasLoadedWorkplannedList = true;
            this.countNbWorkplanned();
            this.countNbWorkplanned(true);
          }
        });
    },
    countNbIncidents(fromSavedList) {
      let nbCurrentIncidents = 0;
      let list = fromSavedList ? this.savedIncidentsList : this.incidentsList;
      this.isNationalIncident = false;

      // Count number of incidents are running
      list.forEach((incident) => {
        if (["validated", "detected"].indexOf(incident.status) !== -1) {
          nbCurrentIncidents += 1;

          if (incident.isNational) {
            this.isNationalIncident = true;
          }
        }
      });

      if (fromSavedList) {
        this.savedNbCurrentIncidents = nbCurrentIncidents;
      } else {
        this.nbCurrentIncidents = nbCurrentIncidents;
      }
    },
    countNbWorkplanned(fromSavedList) {
      let list = fromSavedList ? this.savedWorkplannedList : this.workplannedList;
      let nbCurrentWorkplanned = 0;

      // Count number of workplanned are planned for today
      const currentTimestamp = Date.now();

      list.forEach((work) => {
        const timestampStart = new Date(
          work.dateBegin.replace(" ", "T")
        ).getTime();
        const timestampEnd = new Date(work.dateEnd.replace(" ", "T")).getTime();

        if (
          (timestampStart < currentTimestamp &&
            timestampEnd > currentTimestamp) ||
          (timestampStart > currentTimestamp &&
            timestampStart - 24 * 60 * 60 * 1000 < currentTimestamp)
        ) {
          nbCurrentWorkplanned += 1;
        }
      });

      if (fromSavedList) {
        this.savedNbCurrentWorkplanned = nbCurrentWorkplanned;
      } else {
        this.nbCurrentWorkplanned = nbCurrentWorkplanned;
      }
    },
    onSelectedDepartment(dept) {
      if (dept) {
        // Filter incidents list and workplanned list on selected department
        this.incidentsList = this.savedIncidentsList.filter(
          (incident) => incident.departments.indexOf(dept) !== -1
        );
        this.workplannedList = this.savedWorkplannedList.filter(
          (work) => work.departments.indexOf(dept) !== -1
        );

        this.countNbIncidents();
        this.countNbWorkplanned();
        this.isListFiltered = true;
      } else {
        this.incidentsList = this.savedIncidentsList;
        this.workplannedList = this.savedWorkplannedList;
        this.countNbIncidents();
        this.countNbWorkplanned();
        this.isListFiltered = false;
      }
    },
    refreshData() {
      this.loadIncidentList();
      this.loadWorkplannedList();
      this.isListFiltered = false;
    },
  },
};
</script>

<style>
.main-title {
  margin-bottom: 10px;
  padding-top: 15px;
}
.resume {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.resume-detail {
  display: flex;
  flex-direction: column;
  padding-left: 1rem;
}
.card {
  border-color: #BEF1FF !important;
}
.card-header {
  background-color: #BEF1FF !important;
  color: #00185E;
  border-bottom-color: #BEF1FF !important;
}
.reload-button {
  margin: 1rem;
}

@media (max-width: 900px) {
  .resume {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 1rem;
  }
  .resume-detail {
    display: flex;
    flex-direction: column;
    padding-left: 0;
  }
}
</style>
